import { Box, IconButton, Modal, useMediaQuery } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { blackColor, whiteColor } from "../configs/styles/muiThemes";

export default function ModalCard(props) {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));
  const isMobileBottom = !matches && props.mobileBottom;
  return (
    <Modal open={props.open} onClose={props.handleClose}>
      <Box
        sx={{
          ...style(true, isMobileBottom, props.br),
          width: matches ? props?.width || 600 : props?.mobileWidth || "90%",
        }}
      >
        <Box sx={modalContent}>
          {props.handleClose && (
            <IconButton
              sx={{ ...btnClose, ...props?.closeBtnStyles }}
              onClick={props.handleClose}
            >
              <CloseIcon sx={{ fontSize: 20, color: blackColor }} />
            </IconButton>
          )}
          {props.children}
        </Box>
      </Box>
    </Modal>
  );
}

const style = (transparent, isMobileBottom, br) => ({
  position: "absolute",
  ...(isMobileBottom
    ? {
        bottom: 0,
        left: "50%",
        transform: "translateX(-50%)",
        borderRadius: br ? br : "10px 10px 0 0",
        maxHeight: "80vh",
        overflow: "auto",
      }
    : {
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        borderRadius: "10px",
      }),
  bgcolor: transparent ? null : whiteColor,
  boxShadow: 24,
});

const modalContent = {
  width: "100%",
  height: "100%",
  position: "relative",
};

const btnClose = {
  background: "transparent",
  position: "absolute",
  top: "4px",
  right: "10px",
  width: "30px",
  height: "30px",
  opacity: 1,
  borderRadius: "50px",
  zIndex: "50 !important",
  "&:hover": {
    background: whiteColor,
  },
};
